export const PDF_ID = 1;
export const SKETCH_ID = 2;
export const PHOTO_ID = 3;
